import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useAttributeListByGroup = guid => {
  const [loading, setLoading] = useState(true);
  const [attributeListByGroup, setAttributeListByGroup] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  const getAttributeListByGroup = (params = {}) => {
    setLoading(true);

    axiosClient
      .get(`SettingProduct/GetAllAttributesByGroup?Guid=${guid}`, { params })
      .then(res => {
        if (res.status === 200) {
          setAttributeListByGroup(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return { getAttributeListByGroup, loading, attributeListByGroup };
};

export default useAttributeListByGroup;
